(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

},{}],2:[function(require,module,exports){
"use strict";

require('./modules/polyfills');

require('./modules/goals-counter');

require('./app/header');

require('./app/modal');

require('./app/form');

},{"./app/form":3,"./app/header":4,"./app/modal":5,"./modules/goals-counter":9,"./modules/polyfills":10}],3:[function(require,module,exports){
"use strict";

var _modal = require("./modal");

var _config = _interopRequireDefault(require("../config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var forms = document.querySelectorAll('.form');
forms.forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var data = new FormData(form);
    var modal = form.closest('.modal');
    data.append('to', _config["default"].mailTo);
    data.append('subject', _config["default"].mailSubject);
    var validateErrors = validate(form.querySelectorAll('input'));

    if (Object.keys(validateErrors).length === 0) {
      fetch('https://api-v0.hst11.itglobal.com/form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams(data).toString()
      }).then(function () {
        if (modal) {
          var modalContent = modal.querySelector('.modal__content');
          var modalResponse = modal.querySelector('.modal__response');
          modalContent.classList.add('hide');
          modalResponse.classList.add('show');
        } else {
          (0, _modal.openModal)('modal-success');
        }
      });
    }
  });
  var inputs = form.querySelectorAll('input');
  inputs.forEach(function (input) {
    input.addEventListener('input', inputListener);
  });
});

function inputListener(e) {
  var input =
  /** @var Element */
  e.target;
  input.classList.remove('error');
  input.closest('.form__field').querySelector('.error-msg').remove();
}

function validate(fields) {
  var errors = {};
  fields.forEach(function (field) {
    var parent = field.closest('.form__field');
    console.log(parent);
    var errorMsg = parent.querySelector('.error-msg');

    if (!field.value) {
      field.classList.add('error');

      if (!errorMsg) {
        parent.insertAdjacentHTML('beforeend', '<span class="error-msg">Required</span>');
      }

      errors[field.name] = 'error';
    } else {
      field.classList.remove('error');

      if (errorMsg) {
        errorMsg.remove();
      }
    }
  });
  return errors;
}

},{"../config":6,"./modal":5}],4:[function(require,module,exports){
"use strict";

var body = document.body;
var header = document.querySelector('.header');
var SCROLL_TOP_OFFSET = 50;
window.addEventListener('scroll', function () {
  if (window.scrollY >= SCROLL_TOP_OFFSET) {
    body.classList.add('scrolled');
    header.classList.add('header--scrolled');
  } else {
    body.classList.remove('scrolled');
    header.classList.remove('header--scrolled');
  }
});

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = closeModal;
exports.openModal = openModal;

var _constants = require("../modules/_constants");

var _globalFunctions = require("../modules/global-functions");

var _goalsCounter = _interopRequireDefault(require("../modules/goals-counter"));

var _form = require("./form");

var _bodyScrollLock = require("body-scroll-lock");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var openButtons = document.querySelectorAll('[data-toggle="modal"]') || [];
var closeButtons = document.querySelectorAll('[data-toggle="close-modal"]') || [];
var body = document.querySelector('body');
var header = document.querySelector('.header');
var goalsCounter = new _goalsCounter["default"]();
var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

function closePopupByOuterClick(event) {
  if (!event.target.closest(_constants.MODAL.window) && !(event.target.getAttribute('data-toggle') === 'modal')) {
    closeModal();
  }
}

function openModal(id) {
  var modal = document.getElementById(id);
  modal.dispatchEvent(new CustomEvent('modal:beforeOpen'));

  if (!(0, _globalFunctions.isMobileDevice)()) {
    body.classList.add('lock');
    body.style.paddingRight = scrollbarWidth + 'px';
    header.style.right = scrollbarWidth + 'px';
  }

  if ((0, _globalFunctions.isMobileDevice)()) {
    (0, _bodyScrollLock.disableBodyScroll)(modal, {
      reserveScrollBarGap: true
    });
  }

  setTimeout(function () {
    modal.classList.add('show');
    document.addEventListener('click', closePopupByOuterClick);
  }, 200);
}

function closeModal(modal) {
  modal = modal ? modal : document.querySelector('.modal.show');
  modal.classList.add('out');

  if ((0, _globalFunctions.isMobileDevice)()) {
    (0, _bodyScrollLock.enableBodyScroll)(modal);
  }

  var iframe = modal.querySelector('.modal__content iframe');

  if (iframe) {
    iframe.remove();
  }

  setTimeout(function () {
    // setFormDefaults(false, modal);
    modal.classList.remove('show');
    modal.classList.remove('out');
    body.classList.remove('lock');
    body.style.paddingRight = null;
    header.style.right = null;
  }, 200);
  document.removeEventListener('click', closePopupByOuterClick);
}

openButtons.forEach(function (btn) {
  return btn.addEventListener('click', function (e) {
    e.preventDefault();
    var ymGoal = this.getAttribute('data-ym-goal');

    if (typeof ymGoal !== 'undefined') {
      goalsCounter.sendGoals(ymGoal);
    }

    var target = this.getAttribute('data-target').replace('#', '');
    openModal(target);
  });
});
closeButtons.forEach(function (btn) {
  return btn.addEventListener('click', function () {
    return closeModal();
  });
});
document.addEventListener('keydown', function (event) {
  var modal = document.querySelector('.modal.show');

  if (event.key === 'Escape' && modal) {
    closeModal(modal);
  }
});

},{"../modules/_constants":7,"../modules/global-functions":8,"../modules/goals-counter":9,"./form":3,"body-scroll-lock":1}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  mailTo: 'vg@itglobal.com',
  mailSubject: 'Сообщение с сайта ITPay'
};
exports["default"] = _default;

},{}],7:[function(require,module,exports){
"use strict";

module.exports = Object.freeze({
  AJAX_URL: '/wp-admin/admin-ajax.php',
  FORM: {
    field: '.form__field',
    control: '.form__control',
    error: '.error-msg'
  },
  MODAL: {
    module: '.modal',
    window: '.modal__popup',
    content: '.modal__content',
    response: '.modal__response',
    successId: 'modal-success'
  }
});

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileDevice = void 0;

var isMobileDevice = function isMobileDevice() {
  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
};

exports.isMobileDevice = isMobileDevice;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var GoalsCounter = /*#__PURE__*/function () {
  function GoalsCounter(ymCounterKey) {
    _classCallCheck(this, GoalsCounter);

    this.ymCounterKey = null;

    if (ymCounterKey) {
      this.ymCounterKey = ymCounterKey;
    } else {
      this._findYmCounter(10);
    }
  }

  _createClass(GoalsCounter, [{
    key: "_findYmCounter",
    value: function _findYmCounter(i) {
      var _this = this;

      var yaCounter = Object.keys(window).filter(function (el) {
        return /^yaCounter.*?/i.test(el);
      });

      if (!yaCounter.length) {
        i--;
        setTimeout(function () {
          return _this._findYmCounter(i);
        }, 300);
      } else {
        this.ymCounterKey = yaCounter;
      }
    }
  }, {
    key: "sendGoals",
    value: function sendGoals(ymGoal, gaGoal, fbGoal, linkedinGoal) {
      if (ymGoal && this.ymCounterKey && window[this.ymCounterKey]) {
        window[this.ymCounterKey].reachGoal(ymGoal);
      }

      if (gaGoal && typeof ga === 'function') {
        ga('send', 'event', gaGoal.category, gaGoal.action, gaGoal.label);
      }

      if (typeof fbq !== 'undefined' && fbGoal) {
        fbq('track', fbGoal);
      }

      if (linkedinGoal && window.lintrk) {
        window.lintrk('track', {
          conversion_id: linkedinGoal
        });
      }
    }
  }]);

  return GoalsCounter;
}();

var _default = GoalsCounter;
exports["default"] = _default;

},{}],10:[function(require,module,exports){
"use strict";

/**
 * @link: https://gist.github.com/k-gun/c2ea7c49edf7b757fe9561ba37cb19ca
 */
;

(function () {
  // helpers
  var regExp = function regExp(name) {
    return new RegExp('(^| )' + name + '( |$)');
  };

  var forEach = function forEach(list, fn, scope) {
    for (var i = 0; i < list.length; i++) {
      fn.call(scope, list[i]);
    }
  }; // class list object with basic methods


  function ClassList(element) {
    this.element = element;
  }

  ClassList.prototype = {
    add: function add() {
      forEach(arguments, function (name) {
        if (!this.contains(name)) {
          this.element.className += ' ' + name;
        }
      }, this);
    },
    remove: function remove() {
      forEach(arguments, function (name) {
        this.element.className = this.element.className.replace(regExp(name), '');
      }, this);
    },
    toggle: function toggle(name) {
      return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
    },
    contains: function contains(name) {
      return regExp(name).test(this.element.className);
    },
    // bonus..
    replace: function replace(oldName, newName) {
      this.remove(oldName), this.add(newName);
    }
  }; // IE8/9, Safari

  if (!('classList' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'classList', {
      get: function get() {
        return new ClassList(this);
      }
    });
  } // replace() support for others


  if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
    DOMTokenList.prototype.replace = ClassList.prototype.replace;
  }
})();

if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }

    return null;
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

},{}]},{},[2]);
